import Conts_ from './const'
import { getSession, clearSession } from './session'

export  default async function ApiCall({call, params = {},method = "POST",}) {
    const base = Conts_.apiUrl || `http://${Conts_.ip}:${Conts_.portApi}`;
    const session = getSession();
    let attrs = {
        method,
        headers:{
            'Content-Type':'application/json',
        }
    }

    if(session && session.token)
        attrs.headers['Authorization'] = `Bearer ${session.token}`

    if(method !== "GET" && method !== "DELETE")
        attrs['body'] = JSON.stringify(params)

    return await timeout(60000,
        fetch(`${base}/${call}`,
        attrs),
    ).then(response => {
        // Token vencido o invalido: volver al login
        if(response.status === 401 && call !== "login") {
            clearSession();
            window.location.href = '/auth/login';
        }
        return response.text()
    })
    .then(responseJson=>{
        return JSON.parse(responseJson)
    })
    .catch(err=> {
        return undefined
    })
}

function timeout(ms,promise) {
    return new Promise(((resolve,reject)=>{
        setTimeout(() => {
            reject(JSON.stringify({'err':true}))
        }, ms);
        promise.then(resolve,reject);
    }));   
}
